import React, { useState } from "react";
import { Table } from "antd";

const Content = (props) => {

  const { dataSource,page,onTableChange=()=>{},onShowSizeChange=()=>{} }=props; 

  const columns=[
    {
      title: '评价时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
    {
      title: '运营点位',
      dataIndex: 'pointName',
      key: 'pointName',
    },
    {
      title: '运营商',
      dataIndex: 'operateCompanyName',
      key: 'operateCompanyName',
    },
    {
      title: '品牌商',
      dataIndex: 'brandCompanyName',
      key: 'brandCompanyName',
    },
    {
      title: '评分',
      dataIndex: 'score',
      key: 'score',
      render:(text,record)=>`${text} 分`
    },
    {
      title: '评价内容',
      dataIndex: 'content',
      key: 'content',
    } 
  ]

  return (
    <div className="content">
      <Table
        rowSelection={null}
        dataSource={dataSource}
        rowKey="companyId"
        columns={columns}
        pagination={{
          showTotal: () => `共${page.total}条`,
          total: page.total,
          current: page.pageNum,
          pageSize: page.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "30", "40"],
          onChange: onTableChange,
          onShowSizeChange: onShowSizeChange,
        }}
      /> 
    </div>
  );
};

export default Content;
